import React from 'react';

import CountComponentsControls from './CountComponentsControls';
import CountMaterialsControls from './CountMaterialsControls';
import SequencePlates from './SequencePlates';
import UpdateTreQuantities from './UpdateTreQuantities';

export function Count() {
  return (
    <div>
      <CountMaterialsControls />
      <CountComponentsControls />
      <UpdateTreQuantities />
      <SequencePlates />
    </div>
  );
}
